import { Link } from "react-router-dom";
import PageHelmet from "../../components/shared/PageHelmet";

const NotFound = () => {
    return (
        <>
            <PageHelmet pageTitle="Page Not Found" noIndex />
            <main>
                <div style={{ textAlign: "center", padding: "50px" }}>
                    <h1>404 - Page Not Found</h1>
                    <p>Oops! The page you're looking for doesn't exist.</p>
                    <Link to="/">Go back to Home</Link>
                </div>
            </main>
        </>
    );
};

export default NotFound;
